module.exports = __webpack_public_path__ + "static/media/journalist-database-icon.a3c62986.svg";